import { FunctionCallCache } from "./functionCallCache";
import { FunctionLocationTracker } from "./functionLocationTracker";
import { logger } from "./tslog";
/**
 * Runs a full cleanup of both the tracker and the cache.
 * 1. Cleans up tracker mappings to deleted named ranges
 * 2. Cleans up function calls not referenced in the tracker
 */
export async function runFullCleanup({ log = false } = {}) {
    const tracker = FunctionLocationTracker.getInstance();
    const cache = FunctionCallCache.getInstance();
    const removedTracker = await tracker.cleanup();
    const removedCache = await cache.cleanupUnusedCalls();
    if (log) {
        logger.info("Tracker cleanup: Removed named ranges:", removedTracker);
        logger.info("Cache cleanup: Removed function calls:", removedCache);
    }
    return { removedTracker, removedCache };
}
//# sourceMappingURL=functionCleanup.js.map